__turbopack_context__.v({
  "container": "layout-module__URsdqq__container",
  "content": "layout-module__URsdqq__content",
  "devBorder": "layout-module__URsdqq__devBorder",
  "skipLink": "layout-module__URsdqq__skipLink",
  "wrapper": "layout-module__URsdqq__wrapper",
});
